import { Input } from "antd";
import "./styles.scss";

function Password(props) {
    return (
        <div className="db-input">
            <Input.Password
                className="db-input"
                {...{ ...props, ref: props.inputRef }}
            />
        </div>
    );
}

export default function DBInput(props) {
    return (
        <div className="db-input">
            <Input
                className="db-input"
                {...{ ...props, ref: props.inputRef }}
            />
        </div>
    );
}

DBInput.Password = Password;
